import { render, staticRenderFns } from "./DispositivosSeriadosEdicion.vue?vue&type=template&id=1173b55e&"
import script from "./DispositivosSeriadosEdicion.vue?vue&type=script&lang=ts&"
export * from "./DispositivosSeriadosEdicion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports